module.exports = __webpack_public_path__ + "media/src/assets/lyrnlinkblack-0f0f6d2852d9c0902772df1ca65cd13f.svg";